// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".client-summary__data-display{position:relative;overflow:hidden}.client-summary__data-display ul{margin-left:-1px}.client-summary__data-display li{display:inline-block;margin:.25em 0;padding:0 5px;border-left:1px solid var(--color-silver)}.client-summary .client-item__label{text-transform:uppercase;display:inline}.client-summary .client-item__value{display:inline}", ""]);
// Exports
module.exports = exports;
